import { useEffect, useState } from "react";
import { Form, Input, Button, Divider, Select, Space, Row, Spin } from "antd";
import { ToastService } from "@shared/lib/services";
import styles from "./styles.module.scss";
import { useCreateBucket } from "../lib/hooks/useCreateBucket";
import { ICreateBucketRequest } from "@shared/lib/types/influencer";
import { useGetBucketFacets } from "../lib/hooks/useGetBucketFacets";
import TextArea from "antd/es/input/TextArea";
import { PlusOutlined } from "@ant-design/icons";
const { Option } = Select;

export const BucketForm = ({ closeModal }: { closeModal: () => void }) => {
  const [form] = Form.useForm();
  const { create, isCreating, isCreated } = useCreateBucket();
  const { isFetching, facets } = useGetBucketFacets();
  const [availableCategories, setAvailableCategories] = useState<string[]>([]);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [newCategory, setnewCategory] = useState<string>("");

  const handleFormSubmit = (values: ICreateBucketRequest) => {
    create(values);
  };

  const addNewCategory = (categoryName: string) => {
    if (!categoryName.trim() || availableCategories.includes(categoryName)) {
      return;
    }

    const updatedCategories = [...availableCategories, categoryName];
    setAvailableCategories(updatedCategories);
    setnewCategory("");
    form.setFieldsValue({
      bucketCategory: [
        ...(form.getFieldValue("bucketCategory") || []),
        categoryName,
      ],
    });
    setDropdownOpen(false);
  };
  useEffect(() => {
    if (isCreated) {
      closeModal();
      ToastService.success("Bucket Created");
    }
  }, [isCreated]);
  useEffect(() => {
    if (!isFetching && facets?.category) {
      setAvailableCategories([
        ...facets.category.map((elemrnt) => elemrnt._id),
      ]);
    }
  }, [isFetching]);
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFormSubmit}
      onFinishFailed={({ errorFields }) => {
        if (errorFields.length) {
          ToastService.error(
            "Error Submitting Form. Please fill all required fields."
          );
        }
      }}
    >
      <div className={styles.form}>
        <Form.Item
          name="bucketName"
          label="Bucket Name"
          rules={[{ required: true, message: "Bucket name is required" }]}
        >
          <Input placeholder="Bucket Name" />
        </Form.Item>

        <Form.Item
          name="bucketCategory"
          label="Bucket Category"
          rules={[{ required: true, message: "Bucket category is required" }]}
        >
          <Select
            open={dropdownOpen}
            onDropdownVisibleChange={setDropdownOpen}
            showSearch
            mode="multiple"
            placeholder="Select or create a role"
            optionFilterProp="children"
            allowClear
            dropdownRender={(menu) => {
              return isFetching ? (
                <>
                  <Divider style={{ margin: "8px 0" }} />
                  <Space
                    style={{
                      padding: "0 8px 4px",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  ></Space>
                  <Row
                    style={{
                      margin: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Spin style={{ width: 30, height: 30 }} />
                  </Row>
                </>
              ) : (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space
                    style={{
                      padding: "0 8px 4px",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Input
                      placeholder="Enter new category"
                      value={newCategory}
                      onChange={(e) => setnewCategory(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && newCategory) {
                          e.stopPropagation();

                          e.preventDefault();
                          addNewCategory(newCategory);
                        }
                      }}
                    />
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      disabled={!newCategory}
                      onClick={() => addNewCategory(newCategory)}
                    >
                      Add Category
                    </Button>
                  </Space>
                </>
              );
            }}
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {availableCategories.map((role) => (
              <Option key={role} value={role}>
                {role}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="bucketDescription"
          label="Bucket Description"
          rules={[
            { required: true, message: "Bucket description is required" },
          ]}
        >
          <TextArea rows={8} placeholder="Bucket Description" />
        </Form.Item>
      </div>
      <Divider />
      <div className={styles.footer}>
        <Form.Item>
          <Button
            type="default"
            htmlType="button"
            disabled={isCreating}
            onClick={closeModal}
          >
            Cancel
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            disabled={isCreating}
            loading={isCreating}
          >
            {isCreating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default BucketForm;
